import { MapPin, Phone, Mail } from 'lucide-react';
import { contactInfo } from '../../mock';

const ContactLine = ({ icon: Icon, children }) => (
  <div className="flex items-start gap-4">
    <span className="shrink-0 w-10 h-10 rounded-lg border border-primary/30 bg-primary/10 flex items-center justify-center"><Icon size={16} className="text-accent" /></span>
    {children}
  </div>
);

export const ContactDetails = () => (
  <div>
    <div className="flex items-center gap-3 mb-5"><span className="h-px w-10 bg-primary" /><span className="text-[11px] tracking-[0.28em] text-accent font-medium">ILETISIM</span></div>
    <h2 className="text-[40px] sm:text-[48px] lg:text-[56px] leading-[1.05] font-semibold text-white">Bize Ulasin</h2>
    <p className="mt-5 text-[15px] text-white/55 max-w-md leading-relaxed">Size en uygun cozumu sunmak icin bizimle iletisime gecin.</p>
    <div className="mt-12 space-y-7">
      <ContactLine icon={MapPin}><p data-testid="contact-address" className="text-[14px] text-white/70 leading-relaxed max-w-md pt-2">{contactInfo.address}</p></ContactLine>
      <ContactLine icon={Phone}><a data-testid="contact-phone-link" href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="text-[14px] text-white/70 hover:text-white transition pt-2.5">{contactInfo.phone}</a></ContactLine>
      {contactInfo.emails.map((email) => (
        <ContactLine key={email} icon={Mail}><a data-testid={`contact-email-${email}`} href={`mailto:${email}`} className="text-[14px] text-white/70 hover:text-white transition pt-2.5 break-all">{email}</a></ContactLine>
      ))}
    </div>
  </div>
);